// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import _ from 'underscore';

import { Analytics } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { getScreenFromUrl } from '@trello/marketing-screens';

import { ModelCache } from 'app/scripts/db/ModelCache';
import { ApiPromise } from 'app/scripts/network/ApiPromise';
import { maybeDisplayLimitsErrorOnCardAdd } from 'app/scripts/views/card/CardLimitsError';
import { templates } from 'app/scripts/views/internal/templates';
import { View } from 'app/scripts/views/internal/View';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { ListBulkCardMoveTemplate } from 'app/scripts/views/templates/ListBulkCardMoveTemplate';

interface ListBulkMoveCardsView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
}

class ListBulkMoveCardsView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'move all cards in list';

    // @ts-expect-error TS(2339): Property 'events' does not exist on type 'ListBulk... Remove this comment to see the full error message
    this.prototype.events = { 'click .js-select-list': 'selectList' };
  }

  initialize() {
    Analytics.sendScreenEvent({
      name: 'moveAllCardsInListInlineDialog',
      containers: {
        list: {
          id: this.model.id,
        },
        board: {
          id: this.model.getBoard()?.id,
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id,
        },
      },
    });
  }

  render() {
    const data = this.model.toJSON();
    data.lists = [];

    const lists = this.model.getBoard().listList.models;
    for (const list of Array.from(lists)) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const _list = _.clone(list.toJSON());
      if (_list.id === this.model.id) {
        _list.current = true;
      }
      data.lists.push(_list);
    }

    this.$el.html(templates.fill(ListBulkCardMoveTemplate, data));

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectList(e: any) {
    // eslint-disable-next-line @trello/enforce-variable-case
    const $targetList = $(e.target).closest('.js-select-list');
    const targetListId = $targetList.attr('name');

    if ($targetList.hasClass('disabled')) {
      return;
    }

    const listDest = ModelCache.get('List', targetListId);
    // Copy the original list, since moving the cards will cause the list to
    // change
    const cards = _.clone(this.model.openCards().models);

    if (cards.length > 0) {
      const options = {
        $elem: $(e.target),
        destinationList: listDest,
      };
      if (maybeDisplayLimitsErrorOnCardAdd(options)) {
        return;
      }

      Analytics.sendTrackEvent({
        action: 'moved',
        actionSubject: 'card',
        source: 'moveAllCardsInListInlineDialog',
        attributes: {
          listSourceId: this.model.id || '',
        },
        containers: {
          list: {
            id: targetListId || '',
          },
          board: {
            id: this.model.getBoard()?.id || '',
          },
          organization: {
            id: this.model.getBoard()?.getOrganization()?.id || '',
          },
        },
      });

      const traceId = Analytics.startTask({
        // @ts-expect-error TS(2322): Type '"edit-list/moveAllCards"' is not assignable ... Remove this comment to see the full error message
        taskName: 'edit-list/moveAllCards',
        source: getScreenFromUrl(),
      });

      ApiPromise({
        url: `/1/lists/${this.model.id}/moveAllCards`,
        type: 'POST',
        data: {
          // @ts-expect-error
          idBoard: listDest.getBoard()?.id,
          idList: targetListId,
        },
      })
        .tap(() =>
          Analytics.taskSucceeded({
            traceId,
            // @ts-expect-error TS(2322): Type '"edit-list/moveAllCards"' is not assignable ... Remove this comment to see the full error message
            taskName: 'edit-list/moveAllCards',
            source: getScreenFromUrl(),
          }),
        )
        .catch((error) =>
          Analytics.taskFailed({
            traceId,
            // @ts-expect-error TS(2322): Type '"edit-list/moveAllCards"' is not assignable ... Remove this comment to see the full error message
            taskName: 'edit-list/moveAllCards',
            source: getScreenFromUrl(),
            error,
          }),
        );
    }

    PopOver.hide();
  }
}

ListBulkMoveCardsView.initClass();
export { ListBulkMoveCardsView };
